import React from 'react';

import PendingResultContent from '../PendingResultContent';

function ResultPendingRoomContent({ pendingResultContent, viewProps }) {
  return (
    <>
      <PendingResultContent
        refreshKey={pendingResultContent.refreshKey}
        round={pendingResultContent.round}
      />
    </>
  );
}

export default ResultPendingRoomContent;
